import Sliders from "./page";

export default Sliders;
